import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Text} from '@chakra-ui/react3'
import StackableImage from '../../../leap/components/stackable-image'

const EngravingStackableImage = ({alt, images, engraveText, ...rest}) => {
    const {formatMessage} = useIntl()
    const updatedAlt = engraveText
        ? formatMessage(
              {
                  id: 'configurator.step.engraving.aria-label',
                  defaultMessage: '{alt} - Engraving: {engraveText}'
              },
              {alt, engraveText}
          )
        : alt

    return (
        <StackableImage
            images={images}
            alt={updatedAlt}
            {...rest}
            tabIndex={-1}
            // used by the engraving text layer style
            containerType="size"
        >
            {engraveText && (
                <Text aria-hidden="true" layerStyle="engraving.text" zIndex={10}>
                    {engraveText}
                </Text>
            )}
        </StackableImage>
    )
}

EngravingStackableImage.propTypes = {
    alt: PropTypes.string,
    images: PropTypes.array,
    product: PropTypes.object,
    engraveText: PropTypes.string,
    widths: PropTypes.object
}

export default EngravingStackableImage
